export default {
  myButton: {
    color: 'green',
  },
  bg: {
    background: '#999',
  },
}
